import { HttpClient } from '@angular/common/http';
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  private _message : Subject<string>  = new Subject<string>();

  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

  sendMessage(message: string)
  {   
    this._message.next(message);
  }

  getMessage(): Observable<any> {
    return this._message.asObservable();
  }

  sendEmail(blob){

    let lista:File[]  =[];
    lista.push(blob)

    const formData = new FormData();
    formData.append("ToEmail", 'diogoalvesaraujo@gmail.com');
    formData.append("Subject", 'testess3');
    formData.append("Body", 'testess');
    formData.append("Attachments",blob);

    console.log(this.environmentUrl + "/Login/testMail")
      return this.httpClient.post(this.environmentUrl + "/Login/testMail", formData);
  
  }
}